<div mat-dialog-title>
  <div class="text-truncate title dialog-title" i18n>Соединитель</div>
  <button mat-button class="mat-icon-button" [mat-dialog-close] aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div mat-dialog-content>
  <mat-form-field appearance="outline" class="w-full">
    <mat-label i18n appearance="outline">Количество</mat-label>
    <input matInput placeholder="label" value="value" [formControl]="count" />
  </mat-form-field>
</div>

<div mat-dialog-actions>
  <button i18n mat-raised-button class="mat-accent" [disabled]="count.invalid" (click)="saveAndClose()">ОК</button>
  <button i18n mat-button [mat-dialog-close]>ОТМЕНА</button>
</div>
